type SortWorkExperienceFunctionType = { Egress: string | null } & Record<
  string,
  any
>;

const sortWorkExperienceFunction = (
  a: SortWorkExperienceFunctionType,
  b: SortWorkExperienceFunctionType
) => {
  // If job is in progress (egress: null)
  if (a.Egress === null) return -1;
  if (b.Egress === null) return 1;

  if (new Date(a.Egress) > new Date(b.Egress)) return -1;
  if (new Date(a.Egress) < new Date(b.Egress)) return 1;

  return 0;
};

export default sortWorkExperienceFunction;
